<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="状态：" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>待发货</span>
                    </Radio>
                    <Radio label="2">
                        <span>已发货</span>
                    </Radio>
                    <Radio label="3">
                        <span>已完成</span>
                    </Radio>
                    <Radio label="4">
                        <span>已退货</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '修改状态',//弹框标题
                formData: {//表单数据
                    id: '',
                    status: '1',
                }, 
                ruleCustom: {//验证
                },
            }
        },
        components: {
        },
        watch:{
            showModel(val){
                if(val){
                }
            }
        },
        created(){
            
        },
        methods: {
            
            openOrClose(value) {
                if(value === true) {
                    this.formData.id = this.editFormData.id
                    this.formData.status = String(this.editFormData.status);
                    console.log('赋值',this.formData)
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                            
                        this.axios.post(this.config.urlArray.orderChangeOrder, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.formData.id = ''
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                
            }
        }
    }
</script>
